export function isEditMode() {
    return document.body.getAttribute('data-editmode') === 'true';
}